// extracted by mini-css-extract-plugin
var _1 = "AddNewLocationDialog_actionButton__6rUwV";
var _2 = "AddNewLocationDialog_body__ZnjMc";
var _3 = "AddNewLocationDialog_footer__ypIbI";
var _4 = "AddNewLocationDialog_header__O9J8U";
export { _1 as "actionButton", _2 as "body", _3 as "footer", _4 as "header" }
